import View from '@assets/icons/view.svg'
import { Icon } from '@components/icons/Icon'

export const ViewIcon = Icon(View)
